module.exports = __webpack_public_path__ + "static/assets/f29d067cbad259d83ff3cdeb362b362e.png";